module.exports = __webpack_public_path__ + "img/126.e67a02ac.png";